import { render, staticRenderFns } from "./carta.vue?vue&type=template&id=1c3f7886&scoped=true&"
import script from "./carta.vue?vue&type=script&lang=js&"
export * from "./carta.vue?vue&type=script&lang=js&"
import style0 from "./carta.vue?vue&type=style&index=0&id=1c3f7886&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f7886",
  null
  
)

export default component.exports